import { render } from "./nuestra_cultura.vue?vue&type=template&id=506e0c34"
import script from "./nuestra_cultura.vue?vue&type=script&lang=js"
export * from "./nuestra_cultura.vue?vue&type=script&lang=js"

import "./nuestra_cultura.vue?vue&type=style&index=0&id=506e0c34&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__